module.exports = __webpack_public_path__ + "img/JXZWSZ_logo_icon.209353a1.png";